import React from "react";
import { useTranslation } from "react-i18next";

import { Color } from "../../../Form/Button";

import Modal from "..";

import useStyles from "./styles";

interface Props {
  name: string;
  handleClose?: (isDelete?: boolean) => void;
  open: boolean;
}

const Delete = (props: Props) => {
  const { open, handleClose, name } = props;

  const { t: translate } = useTranslation();

  const classes = useStyles();

  return (
    <Modal
      open={open}
      title={`Delete ${name}`}
      showActionButtons
      actionButtonProps={{
        customColorCancel: Color.DEFAULT,
        customColorSave: Color.ERROR,
        textSave: translate("delete"),
        textCancel: translate("cancel"),
        onSave: () => handleClose && handleClose(true),
        onCancel: () => handleClose && handleClose(false)
      }}
      handleClose={() => handleClose && handleClose(false)}
    >
      <span className={classes.description}>
        Do you really want to delete the {name}?
      </span>
    </Modal>
  );
};

export default Delete;
